<article class="collect" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header [class.customized-height]="order_open_amount>0">
    <div class="process">
      <div>&nbsp;</div>
      <sot-stepper activeStep="done"></sot-stepper>
    </div>
    <h1 langkey="done_title"></h1><!--Ihre Bestellung war erfolgreich-->
    <div inlineSVG="sot/sot-icon.svg#sot-done" flex [setSVGAttributes]="{class: 'check-icon'}"></div>
  </header>

  <div class="content">
    <ng-container *ngIf="order_open_amount > 0">
      <div class="remaining_amount">
        <h3 langkey="done_voucher_pay_attention"></h3>
        <h3 class="remaining_amount__info"> {{order_open_amount |price}}</h3>
        <h3 langkey="done_voucher_open_amount"></h3>
      </div>
    </ng-container>
    <div class="box" [class.margin--customized]="hasCollectedBonusPoints||redeemBenefitStateFailed">
      <h3 langkey="done_orderno"></h3><!--dein Bestellcode lautet:-->
      <p class="code">{{order_no}}</p>
      <p langkey="done_preparing" class="highlight"></p><!--Ihre Bestellung wird jetzt zubereitet.-->
      <p langkey="done_info"></p>
      <!--Bitte begeben Sie sich zur Ausgabe und warten darauf, dass wir Ihren Bestellcode aufrufen.-->
    </div>
    <ng-container *ngIf="redeemBenefitStateFailed">
      <h3 class="benefit--redeem-failed" langkey="done_benefits_hint_text"></h3>
    </ng-container>

    <ng-container *ngIf="hasCollectedBonusPoints">
      <h3 langkey="done_voucher_new_bonus_points"></h3>
      <div class=" box bonus-content">
        <ng-container *ngFor="let bonus_points of order_bonus_points">
          <div class="bonus-info">
            <div class="bonus-label">
              <p class="text-content" langkey="done_voucher_bonus_action_name"></p>
              <p class="text--emphasized">{{bonus_points.label_de}}</p>
            </div>
            <div class="bonus-points">
              <p class="text-content" langkey="done_voucher_bonus_action_pts"></p>
              <p class="text--emphasized">{{bonus_points.points}}</p>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="hasMoreBonus">
          <div class="bonus-info more-bonus">
            <p langkey="done_voucher_bonus_points_info"></p>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <sot-countdown [controls]="true" [countdown_sec]="20"
      (statusChanged)="countdownStatusChanged($event)"></sot-countdown>

    <p langkey="done_home" class="counter_msg highlight"></p><!--Sie werden zur Startseite weitergeleitet.-->
    <a (click)="newOrder()" langkey="button_home" class="btn"></a><!--Neue Bestellung-->
  </div>

  <footer *ngIf="show_questions">
    <h2>Dürfen wir Ihnen noch ein paar Fragen stellen?</h2>
    <div class="buttons">
      <a href="" class="btn active">ja</a>
      <a href="" class="btn active">nein</a>
    </div>
  </footer>
</article>